export enum PageName {
  LOGIN_PAGE = 'LoginPage',
  LOGIN_LAYOUT = 'LoginLayout',
  MAIN_LAYOUT = 'MainLayout',
  ORDERS_PAGE = 'OrdersPage',
  ASSIGN_PAGE = 'AssignPage',
  ALL_ORDERS = 'AllOrders',
  ORDER_DETAILS = 'OrderDetail',
  ALL_ASSIGNS = 'AllAssigns',
  MY_ASSIGNS = 'MyAssigns',
  CREATED_ORDER = 'CreateOrder',
  BASKET = 'Basket',
  BONUSES = 'Bonuses',
  TASKS_PAGE = 'TasksPage',
  TASK_DETAILS = 'TaskDetail',
  ALL_TASKS = 'AllTasks',
  AI_CONSULTANT = 'AiConsultant',
  OUTBOX_NOTIFICATIONS = 'OutboxNotifications',
  ERROR_404 = 'Error_404',
  ERROR_500 = 'Error_500',
  ERROR_403 = 'Error_403',
}
